import { lazy, Suspense } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import GuestGuard from "../guards/GuestGuard";
import AuthGuard from "../guards/AuthGuard";
import AdminLayout from "../pages/Admin/Layout/AdminLayout";
import Loader from "../components/Loader";

const Loadable = (Component) => (props) => {
  return (
    <Suspense fallback={<Loader />}>
      <Component {...props} />
    </Suspense>
  );
};

export default function Router() {
  return useRoutes([
    {
      path: "/",
      element: (
        <GuestGuard>
          <Login />
        </GuestGuard>
      ),
    },
    {
      path: "/admin",
      element: (
        <AuthGuard>
          <AdminLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: "/admin/dashboard",
          element: (
            <AuthGuard>
              <Dashboard />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/bots",
          element: (
            <AuthGuard>
              <Bots />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/add-bot",
          element: (
            <AuthGuard>
              <AddBot />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/edit-bot",
          element: (
            <AuthGuard>
              <EditBot />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/flows",
          element: (
            <AuthGuard>
              <Flows />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/add-flow",
          element: (
            <AuthGuard>
              <AddFlow />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/edit-flow",
          element: (
            <AuthGuard>
              <EditFlow />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/view-flow",
          element: (
            <AuthGuard>
              <ViewFlow />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/conversations",
          element: (
            <AuthGuard>
              <Conversations />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/conversations/:id",
          element: (
            <AuthGuard>
              <Conversations />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/leads",
          element: (
            <AuthGuard>
              <Leads />
            </AuthGuard>
          ),
        },
        {
          path: "/admin/users",
          element: (
            <AuthGuard>
              <Users />
            </AuthGuard>
          ),
        },
      ],
    },
    {
      path: "*",
      children: [
        { path: "404", element: <NotFound /> },
        { path: "*", element: <Navigate to="/404" replace /> },
      ],
    },
  ]);
}

const NotFound = Loadable(lazy(() => import("../pages/404/Page404")));

//=====================WEBSITE===============

const Login = Loadable(lazy(() => import("../pages/Admin/auth/Login")));

const Dashboard = Loadable(
  lazy(() => import("../pages/Admin/Dashboard/Dashboard"))
);
const Bots = Loadable(lazy(() => import("../pages/Admin/bots/Bots")));
const AddBot = Loadable(lazy(() => import("../pages/Admin/bots/AddBot")));
const EditBot = Loadable(lazy(() => import("../pages/Admin/bots/EditBot")));
const Flows = Loadable(lazy(() => import("../pages/Admin/flows/Flows")));
const AddFlow = Loadable(lazy(() => import("../pages/Admin/flows/AddFlow")));
const EditFlow = Loadable(lazy(() => import("../pages/Admin/flows/EditFlow")));
const ViewFlow = Loadable(lazy(() => import("../pages/Admin/flows/ViewFlow")));
const Conversations = Loadable(
  lazy(() => import("../pages/Admin/conversations/Conversation"))
);
const Users = Loadable(lazy(() => import("../pages/Admin/users/Users")));
const Leads = Loadable(lazy(() => import("../pages/Admin/leads/Leads")));
